import { elisaKukaSoittaaMsg, t } from '../../common/i18n';

export const reissunetti2GtContent = () => (
  <>
    <h5>Elisa Reissunetti</h5>
    <p>
      {t.IU66(
        'Elisa Reissunetti 2 GB activates automatically when you arrive in the destination country. Reissunetti enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €26.90 / 14 days.'
      )}
    </p>
  </>
);

export const reissunetti1GtContent = () => (
  <>
    <h5>Elisa Reissunetti</h5>
    <p>
      {t.IVLR(
        'Elisa Reissunetti 1-1.5 GB activates automatically when you arrive in the destination country. Reissunetti enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €21.90 / 14 days.'
      )}
    </p>
  </>
);

export const elisaReissunettiContent = () => (
  <>
    <h5>Elisa Reissunetti</h5>
    <p>
      {t.N1Z2(
        'Reissunetti service activated by text message. When you travel in Reissunetti countries, you will automatically receive a subscription text message. Data package price €20.90/subscription.'
      )}
    </p>
  </>
);

export const voiceMinutesContent = (minute: string) => (
  <>
    <h5>{`${t.N1Y6('Voice minutes')} ${minute}min`}</h5>
    <p>
      {t.N1Y7(
        'Calls exceeding the package and calls to landline numbers €0.199/min or pcs. A larger voice package is available for an additional fee upon subscription.'
      )}
    </p>
  </>
);

export const textMessageContent = () => (
  <>
    <h5>{t.N1Y4('Text messages charges based on usage')}</h5>
    <p>
      {t.N1Y9(
        'Domestic standard-priced text messages €0.199/message. A larger text message package is available for an additional fee upon subscription.'
      )}
    </p>
  </>
);

export const reissaajaContent = () => (
  <>
    <h5>Reissaaja</h5>
    <p>
      {t.VTE2(
        'Elisa Reissaaja 500 MB activates automatically when you arrive in the destination country. Reissaaja enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €10.90 / 1 day.'
      )}
    </p>
  </>
);

export const mobiiliturvaContent = () => (
  <>
    <h5>{t.EH0U('Elisa Mobiiliturva for companies')}</h5>
    <p>
      {t.SG3Q(
        'Elisa Mobiiliturva for companies is a new security service for mobile subscriptions. The service identifies malicious websites, securing the use of your subscription.'
      )}
    </p>
  </>
);

export const itsenainen5GVerkkoContent = () => (
  <>
    <h5>{t.ELB0('Works over our standalone 5G+ network')}</h5>
    <p>
      {t.ZZ8N(
        '5G subscriptions always use the best and quickest available connection. In areas without 5G coverage, they switch to 4G network instead. Using a 5G+ subscription can cut delay times by half. The new 5G+ technology also saves your phone’s battery, which makes it a more energy-efficient option.'
      )}
    </p>
  </>
);

export const LiikkuvaWifiPopOverContent = () => (
  <p>{t.Q8ZW('Includes a battery-powered portable mobile router with the best battery life on the market.')}</p>
);

export const ManagedServicePopoverContent = () => (
  <div>{t.AG7I('If the device is damaged, you will receive a new one immediately.')}</div>
);

export const CallsAsPerUsageContent = () => (
  <div>
    <h5>{t.N1Y2('Calls charges based on usage')}</h5>
    <p>{t.N1Z8('Domestic standard-rate calls, calls to landlines and text messages €0.199/min or per sms.')}</p>
  </div>
);

export const KukaSoittaaContent = () => (
  <div>
    <h5>{t.ZKZZ(elisaKukaSoittaaMsg)}</h5>
    <p>
      {t.N1Z4(
        'The service automatically displays the caller’s name information on your phone, even if the number is not saved in your address book.'
      )}
      <a href="/kukasoittaa">{t.N1Z5('Read more about the Kuka Soittaa service.')}</a>
    </p>
  </div>
);

export const ScamCallBlockerContent = () => (
  <div>
    <h5>{t.CQCX('Scam call blocker')}</h5>
    <p>
      {t.NV83(
        'The origin of calls from abroad and Finnish phone numbers are verified in Elisa’s network. Suspicious scam calls are blocked, and the call is connected only if the number is trustworthy.'
      )}
    </p>
  </div>
);

export const MobiilivarmenneContent = () => (
  <div>
    <h5>{t.N1Z6('Elisa Mobiilivarmenne')}</h5>
    <p>
      {t.N1Z7(
        'Elisa Mobiilivarmenne offers secure identification for digital services. Registering a mobile certificate for corporate subscriptions is free of charge and does not include monthly fees.'
      )}
    </p>
  </div>
);

export const DomesticData0GBContent = () => (
  <div>
    <h5>EU-data {t.M09Z('{} GB', '0')}</h5>
    <p>
      {t.N2A2(
        'This subscription only works within Finland. Choose another type of subscription if you need a subscription abroad as well.'
      )}
    </p>
  </div>
);

export const MobiiliturvaYrityksilleContent = () => (
  <>
    <h5>{t.EH0U('Elisa Mobiiliturva for companies')}</h5>
    <p>
      {t.N2A6(
        'Elisa Mobiiliturva for companies is a new type of information security service for mobile subscriptions. The service identifies malicious websites and provides digital security when using your mobile subscription.'
      )}
    </p>
  </>
);
